import { storage } from '@visiba/std';
import type { Settings } from '../features/settings/user_settings.service';
import type { CreateNewMessageSettings } from '@view/view_create_new_message/create_new_message_settings.service';
import type { BookingSettingsRaw } from '@view/view_booking/view_booking_settings.service';

export const applicationLocalStorage = storage<{
	USER_SETTINGS: Settings;
	identitySession: string;
	webVersion: string;
	createNewMessageSettings: Record<number, CreateNewMessageSettings>;
	bookingSettings: Record<number, BookingSettingsRaw>;
	'shell-variant': 'shell' | 'shell-2' | 'shell-3';
	cookieConsentRevision: {
		version: number;
		timestamp: string;
		consent: number;
	};
}>({ type: 'local' });
